module.exports = __webpack_public_path__ + "assets/img/noCaptch.63982b42.png";